// extracted by mini-css-extract-plugin
export default {"btnStyle":"connect_btnStyle__p1-4g","connectBtn":"connect_connectBtn__5yRZp","animatedgradient":"connect_animatedgradient__f-hAT"};